import { CURRENCIES } from "currency/model"
import { PaymentAPI } from "generated-api"
import { checkIfSessionIsOrWillExpired, getUserAgency } from "user/tools/common"
import { IPayment, IPaymentInfo, IPaymentRepository } from "./model"

export const paymentRPO: IPaymentRepository = {
  getStripePublicAPIKey(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        PaymentAPI.getApiPaymentStripeApiPublicKey()
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting stripe public API key", error)
            reject("payment.get.stripe.public.key.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting stripe public API key", ex)
        reject("payment.get.stripe.public.key.error.unexpected")
      }
    })
  },
  initiatePayment(amount: number): Promise<IPaymentInfo> {
    return new Promise<IPaymentInfo>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        PaymentAPI.putApiPaymentAgencyBudget({
          amount,
          agency_currency_id: getUserAgency().currency.id.toUpperCase() as CURRENCIES
        })
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while initiating payment", error)
            reject("payment.initiate.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while initiating payment", ex)
        reject("payment.initiate.error.unexpected")
      }
    })
  },
  getAllPaymentsForMyAgency(): Promise<IPayment[]> {
    return new Promise<IPayment[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        PaymentAPI.getApiPaymentAgencyBudgetDbSucceededList()
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting all agency payments", error)
            reject("payment.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all agency payments", ex)
        reject("payment.get.all.error.unexpected")
      }
    })
  },
  checkStripeCustomerId(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        PaymentAPI.postApiPaymentAgencyBudgetStripeCheckCustomer()
          .then(response => resolve(response.exist))
          .catch((error: any) => {
            console.error("Server error while checking stripe customer id", error)
            reject("payment.check.stripe.customer.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while checking stripe customer id", ex)
        reject("payment.check.stripe.customer.error.unexpected")
      }
    })
  }
}
